import styled from "@emotion/styled";

export const Container = styled.div`
  margin-top: 1.5625rem;
`;

export const UpperContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ContentWrapper = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  gap: 25px;
`;

export const UpperTextWrapper = styled.div``;

export const DisplayRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px dashed #e0e0e0;
  padding-bottom: 22.5px;
  &:last-of-type {
    border-bottom: none;
  }
`;

export const TextWrapper = styled.div`
  display: block;
  @media (max-width: 975px) {
    padding-bottom: 0px !important;
    h2 {
      padding-bottom: 0px !important;
      margin-bottom: 0px !important;
    }
  }
`;

export const InputWrapper = styled.div`
  width: auto;
`;
